/** Matches "prefix-number/bank_code" or "number/bank_code" (CZ). */
const CZ_BANK_ACCOUNT_RE = /^(?:\d{1,6}-)?\d{1,10}\/\d{4}$/;

/**
 * Lightweight IBAN check - format only, no MOD-97 validation.
 * Two country letters + 2 check digits + up to 30 alphanumerics.
 */
const IBAN_LITE_RE = /^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/;

/**
 * Strip whitespace from raw bank account input.
 *
 * @param {unknown} value
 * @returns {string}
 */
function stripBankAccountWhitespace(value) {
  if (typeof value !== "string") return "";
  return value.replace(/\s+/g, "").trim();
}

/**
 * Returns whether the value matches the CZ or IBAN-lite bank account format
 * (same rules as backend `validateBankAccount`).
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidBankAccount(value) {
  return normalizeBankAccount(value) != null;
}

/**
 * Normalize a bank account string (CZ format or IBAN-lite).
 *
 * @param {unknown} value - raw user input
 * @returns {string|null} trimmed (and uppercased for IBAN) bank account, or null when invalid
 */
export function normalizeBankAccount(value) {
  const trimmed = stripBankAccountWhitespace(value);
  if (trimmed.length === 0) return null;

  if (CZ_BANK_ACCOUNT_RE.test(trimmed)) return trimmed;

  const upper = trimmed.toUpperCase();
  if (IBAN_LITE_RE.test(upper)) return upper;

  return null;
}
